import * as React from "react";
import {ConfigState} from "../reducers/config";
import {connect} from "react-redux";
import {ApplicationState} from "../reducers/index";
import ReCAPTCHA from "react-google-recaptcha";
import {ensureToken, tokenValidated} from "../actions/token";
import {apiPost} from "../actions/common";

export const Recaptcha: React.SFC<ConfigState> = (props: ConfigState) => {
    // const onChange = (value: string) => {
    //     apiPost("/auth/validate", {response: value})
    //         .then(_ => tokenValidated(true));
    // };

    //let captcha: any;

    // setTimeout(() => {
    //     ensureToken().then(token => {
    //         if (!token.validated && captcha) {
    //             captcha.execute();
    //         }
    //     });
    // }, 10000);

    // if (props.recaptchaSiteKey) {
    //     return <ReCAPTCHA ref={(r: any) => captcha = r}
    //                       size="invisible"
    //                       sitekey={props.recaptchaSiteKey}
    //                       onChange={onChange}/>;
    // } else {
    //     return null;
    // }
    return null;
};

const connected = connect((state: ApplicationState) => ({
    ...state.config
}))(Recaptcha);

export default connected;



// WEBPACK FOOTER //
// ./src/components/Recaptcha.tsx